<template>
  <el-container style="height: 100%;">
    <el-header style="padding: 0px;">
      <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
    </el-header>
    <el-main>
      <el-timeline>
        <el-timeline-item :timestamp="item.accountdate" placement="top" v-for="(item,idx) in cardBeddings" :key="idx">
          <el-card>
            <p>铺 垫 人:<span style="color: #409EFF">{{item.beddingname}}</span></p>
            <p>成 交 率:<span style="color: #409EFF">{{$percentgae(item.lv)}}</span></p>
            <p>铺垫内容:<span style="color: #409EFF">{{item.bedding}}</span></p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      cardBeddings:[],
      storeid:"",
      cardid:"",
    }
  },
  created() {
    this.storeid=this.$route.query.storeid;
    this.cardid=this.$route.query.cardid;
    let staffid=this.$route.query.staffid;
    if(staffid) {
      this.getTonKenByStaff(staffid);
    }
    else{
      this.getCardBendingByStoreCardId();
    }
  },
  methods:{
    getTonKenByStaff(staffid){
      this.$post("wechatback/getTonKenByStaff",{staffid:staffid}).then(res=>{
        let data=res.object;
        localStorage.setItem("token", data.token);
        localStorage.setItem("staffid", data.staff.staffid);
        localStorage.setItem("querystaffid", data.staff.staffid);
        localStorage.setItem("deptid", data.staff.deptid);
        localStorage.setItem("staffname", data.staff.staffname);
        localStorage.setItem("posid", data.staff.posid);
        localStorage.setItem("storename",data.staff.storename);
        localStorage.setItem("storeid",data.staff.storeid);
        localStorage.setItem("parentstoreid",data.staff.storeid);
        this.getCardBendingByStoreCardId();
      })
    },
    getCardBendingByStoreCardId(){
      this.$post("cardmanager/getCardBendingByStoreCardId",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
        if(res.sucess){
          this.cardBeddings=res.object;
        }
        else{
          this.$message.error(res.message);
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/beauty/cardbeddinginfo.vue